export const PageFeatureFlags = {
  ShowCanadaPostBanner: 'show-canada-post-banner',
  CreditPassCreditIntentToReg: 'credit.pass-credit-intent-to-registration',
} as const;
